
import Vue from "vue";

export default Vue.extend({
  data: function() {
    return {
      open: true,
      hide: false
    };
  },
  props: {
    title: {
      type: String,
      default: "Do you need assistance?"
    },
    messages: {
      type: Array
    },
    toggleByClick: {
      type: Boolean,
      default: true
    },
    allowToggle: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toggle: function() {
      if (this.allowToggle) {
        this.open = !this.open;
      }
      this.$emit("toggle", this.open);
    },
    hideAll: function() {
      this.hide = !this.hide;
    }
  },
  watch: {
    toggleByClick: {
      immediate: true,
      handler: function(newVal: boolean) {
        this.open = newVal;
      }
    }
  }
});
